import styled, { css } from "styled-components";

const ButtonWrapper = styled.button`
	all: unset;
	display: ${(props) => props.style.display ?? "flex"};
	box-sizing: border-box;
	font-family: ${(props) => props.style.fontFamily ?? "pf_handbook_proregular"};
	font-weight: ${(props) => props.style.fontWeight ?? "400"};
	font-size: ${(props) => props.style.fontSize ?? "20px"};
	padding: ${(props) => props.style.padding ?? "0.75em 1em"};
	background-color: var(--color-dirt_brown);
	border-radius: ${(props) =>	props.style.borderRadius ? props.style.borderRadius : "5px"};
	text-align: center;
	color: var(--color-white);
	border: 15px solid blue; // var(--color-dirt_brown);
	width: 100%;
	min-width: fit-content;
	max-width: 100%;
	transition: 0.15s;
	width: ${(props) => (props.style.width ? props.style.width : "100%")};
	height: ${(props) => (props.style.height ? props.style.height : "100%")};
	margin: ${(props) => (props.style.margin ? props.style.margin : "auto")};	
	box-shadow: ${(props) =>
		props.style.boxShadow
			? props.style.boxShadow
			: "rgb(229 229 229) 1px 1px 11px, rgb(255, 255, 255) -1px -1px 17px"};

	&:hover {
		cursor: pointer;
		background-color: var(--color-dirt_brown_dark);
	}
	&:focus {
		outline: none;
	}
	&:active {
		outline: none;
		transform: scale(0.95) !important;
	}
	&:disabled {
		color: var(--color-light_blue_grey);
		background-color: var(--color-pale_grey);
		border: 1.5px solid var(--color-pale_grey);
		cursor: not-allowed;
		box-shadow: none;
		${(props) =>
			props.bordered &&
			css`
				color: var(--color-light_blue_grey);
				background-color: var(--color-white);
				border: 1.5px solid var(--color-light_blue_grey);
				&:hover {
					background-color: var(--color-white);
				}
			`};
	}

	.content {
		display: flex;
		flex-direction: ${(props) => props.style.flexDirection ?? "column"};
		column-gap: ${(props) => props.style.flexDirection === "row" ? "12px" : "0px"};
		justify-content: ${(props) => props.style.flexDirection === "row" ? "flex-start" : "center"};
		text-align: center;
		width: 100%;
		height: 100%;
	}

	.text {
		width: 100%;
		color: white;
		font-family: ${(props) => props.style.fontFamily ?? "pf_handbook_proregular"};
		font-weight: ${(props) => props.style.fontWeight ?? "400"};
		font-size: ${(props) => props.style.fontSize ?? "20px"};
	}

	${'' /* ${(props) =>  // console.log("PROPS: ", props.disabled) } */}

	${(props) => props.disabled &&
		css`
			.parent{
				all: unset;
				color: var(--color-light_blue_grey);
				background-color: var(--color-pale_grey);
				border: 1.5px solid var(--color-pale_grey);
				cursor: not-allowed;
				box-shadow: none;
			}
	`};

	${(props) =>
		props.bordered &&
		css`
			color: var(--color-tan_two);
			background-color: var(--color-white);
			border: 1.5px solid var(--color-tan_two);
			box-shadow: none;
			&:hover {
				background-color: var(--color-white);
			}
		`};

	${(props) =>
		props.mobile &&
		css`
			font-size: 1.2rem;
			padding: 0.75em 1em;
		`};
`;

function CustomButton(props) {
	return (
		<ButtonWrapper {...props} className="parent">
			<div className="content">
				{props.icon ? <div className="icon">{props.icon}</div> : <></>}
				<div className="text">{props.text}</div>
			</div>
		</ButtonWrapper>
	);
}

export default CustomButton;
